//import the Polymer library
import "@polymer/polymer/lib/elements/dom-if.js";
import { html, PolymerElement } from "@polymer/polymer/polymer-element.js";
import General from "../../../../utils/General";
import { labelBanner } from "../../../../utils/WebinarDetail";

import "./VideoPlayer.style";

class VideoPlayer extends PolymerElement {
  static get template() {
    return html`
      <link href="https://vjs.zencdn.net/7.20.1/video-js.css" rel="stylesheet" />
      <style include="video-player-style"></style>
      <div class="container-video">
        <video
            id="webinar_video_player"
            class="video-js vjs-default-skin vjs-big-play-centered"
            controls
            preload="auto"
            poster="{{urlBanner}}"
            data-setup=''
        >
            <source src="{{url}}" type="{{type}}">
        </video>
        <div id="banner-webinar" class$="banner-label  [[labelBanner(status)]]">{{statusText}}</div>
      </div>
    `;
  }

  static get properties() {
    return {
      url: {
        type: String,
        value: null,
      },
      urlLive: {
        type: String,
        value: null,
      },
      urlRecording: {
        type: String,
        value: null,
      },
      urlBanner: {
        type: String,
        value: null,
      },
      type: {
        type: String,
        value: null,
      },
      status: {
        type: String,
        value: null,
      },
      statusText: {
        type: String,
        value: null,
      },
      labelBanner: {
        type: Function,
        value: () => labelBanner
      },
      recording10: {
        type: Boolean,
        value: false,
      },
      recording25: {
        type: Boolean,
        value: false,
      },
      recording50: {
        type: Boolean,
        value: false,
      },
      recording75: {
        type: Boolean,
        value: false,
      },
      recording90: {
        type: Boolean,
        value: false,
      },
    };
  }

  ready() {
    super.ready();
    if (this.urlLive || this.urlRecording) this.type = General.formatVideo((this.url = this.urlLive || this.urlRecording)); //isi value type
    if (this.urlLive && this.status == "live") this.url = this.urlLive;
    if (this.urlRecording && this.status == "finished") this.url = this.urlRecording;
    this.initPlayer();
  }

  initPlayer() {
    window.videojs.log.level("off"); //disable log warning
    const thumbnail = this.shadowRoot.querySelector("#banner-webinar"); //banner
    this.player = videojs(this.shadowRoot.querySelector("#webinar_video_player"), {
      liveui: true,
      autoplay: true,
      muted: true,
      errorDisplay: false,
    });

    if (this.status === "live") this.player.controlBar.progressControl.disable();
    this.intervalIdLive = null;
    this.intervalIdRecording = null;
    this.timeLive = 0;

    this.player.on("pause", () => {
      // on video pause
      this.dispatchEvent(new CustomEvent("player", { detail: "pause" }));
      clearInterval(this.intervalIdLive);
      clearInterval(this.intervalIdRecording);
    });

    this.player.on("play", () => {
      // on video play
      thumbnail.classList.add("banner-hide");
      this.dispatchEvent(new CustomEvent("player", { detail: "play" }));
      if(this.status == "live") {
        this.intervalIdLive = setInterval(() => {
          this.timeLive += 5;
          this.dispatchEvent(new CustomEvent("tracking-time-live", { detail: this.timeLive }));
        }, 300000);
      } else {
        this.intervalIdRecording = setInterval(() => {
          const currentTime = this.player.currentTime();
          const totalDuration = this.player.duration();
          const percentage = (currentTime / totalDuration) * 100;
          if(percentage >= 10 && !this.recording10) {
            this.dispatchEvent(new CustomEvent("tracking-progress-recording", { detail: 10 }));
            this.recording10 = true;
          } else if(percentage >= 25 && !this.recording25) {
            this.dispatchEvent(new CustomEvent("tracking-progress-recording", { detail: 25 }));
            this.recording25 = true;
          } else if(percentage >= 50 && !this.recording50) {
            this.dispatchEvent(new CustomEvent("tracking-progress-recording", { detail: 50 }));
            this.recording50 = true;
          } else if(percentage >= 75 && !this.recording75) {
            this.dispatchEvent(new CustomEvent("tracking-progress-recording", { detail: 75 }));
            this.recording75 = true;
          } else if(percentage >= 90 && !this.recording90) {
            this.dispatchEvent(new CustomEvent("tracking-progress-recording", { detail: 90 }));
            this.recording90 = true;
          }
        }, 1000);
      }
    });

    this.player.on("autoplay", () => {
      // on video start autoplay
      this.dispatchEvent(new CustomEvent("player", { detail: "autoplay" }));
    });

    this.player.on("ended", () => {
      // on video end
      this.dispatchEvent(new CustomEvent("player", { detail: "ended" }));
      clearInterval(this.intervalIdLive);
      clearInterval(this.intervalIdRecording);
    });
  }
}
customElements.define("video-player", VideoPlayer);